import * as React from "react";

import ThaloLogo from "@/assets/thalo-light.png";
import { cn } from "@/lib/utils";

interface AuthFrameProps extends React.HTMLAttributes<HTMLDivElement> {
}

export function AuthFrame({ className, ...props }: AuthFrameProps) {
  const pageIntro = () => (
    <div className="text-center justify-center text-white">
      <div className="mt-1 mb-2 text-2xl">
        You've got a Copilot.
      </div>
      <div className="text-xl">
        Your service tools just got smarter.
      </div>
    </div>
  );

  return (
    <div className="auth-frame animate-bg-pan-br">
      <div className="flex items-center justify-center h-screen p-6">
        <div className="flex flex-col items-center justify-center ">
          <img src={ThaloLogo} className="w-[300px] mb-8" alt="Logo"/>
          <div className="text-xl text-white mb-14">
            <p>
              {pageIntro()}
            </p>
          </div>

          <div className={cn("col-span-12 lg:col-span-12 flex justify-center", className)} {...props} >
            {props.children}
          </div>
        </div>
      </div>


    </div>
  );
}
